<template>
  <div class="h-100">
    <m-content-wrapper :content-type="contentType" :content-category="contentCategory">
      <template v-slot="{ contents,pagination,changePageFunction }">
        <swiper id="contentSlider2" v-bind="swiperOptions" :navigation="true" :modules="modules"
                class="contentSlider2 h-100 w-100">

          <swiper-slide v-for="content in contents" :key="content.id" class=" w-100">
            <component :is="contentCard" :content="content"/>
          </swiper-slide>

        </swiper>


      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from '../../Tags/A'
import mImg from '../../Tags/Img'

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, EffectFade} from 'swiper';
// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";
import 'swiper/css/effect-fade';

// import required modules
import {Navigation} from "swiper";

import {Cards} from "../Card/Cards";

export default {
  name: "ContentSlider2",
  props: {
    contentType: {
      default: 'page'
    },
    contentCategory: {
      type: Object,
      default: ['header-slider']
    },
    contentCard: {
      options: Object.keys(Cards),
      default: 'mContentCard908'
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    autoPlayDuration: {
      default: 1000,
    },
  },
  components: {Swiper, SwiperSlide, mContentWrapper, mA, mImg, ...Cards},
  setup() {
    return {
      modules: [Navigation,Autoplay, EffectFade],
    };
  },
  data() {
    return {
      swiperOptions: {

      },
    };
  },
  beforeMount() {
    if (this.autoPlay) {
      this.swiperOptions['autoplay'] = {
        delay: this.autoPlayDuration,
        disableOnInteraction: false,
      }
    }
  }
};
</script>

<style scoped>

</style>